export default __webpack_public_path__ + "sounds/Bullet-66e65de47dd426656c547e5498e93364.wav";